import { render, staticRenderFns } from "./modal_cadastro_cliente.vue?vue&type=template&id=54d3bf35"
import script from "./modal_cadastro_cliente.vue?vue&type=script&lang=js"
export * from "./modal_cadastro_cliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports